import React, {useEffect} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Space, Table} from "antd";
import {Link} from "react-router-dom";
import Icon from "./Icon";
import {setKey} from "../util/util";
import MatchHeroInfo from "./MatchHeroInfo";
import Mvp from "./Mvp";
import Svp from "./Svp";
import Captain from "./Captain";

export default (prop) => {

    const {t} = useTranslation()
    const game = prop.game
    const team = prop.team

    const columns = [
        {
            key: 'heroId',
            dataIndex: 'heroId',
            title: t('heroListTitle.hero'),
            render: (heroId, r) => <div style={{ position: "relative" }}>

                <Space>
                    <Link to={`/hero/${heroId}`}>

                        <Icon type={'hero'} name={heroId} size={36} />
                    </Link>
                <Link style={{fontSize: "18px"}} to={`/player/${r.playerHandle}`}>
                    <span>{r.playerName}</span><span style={{color: "red"}}>{r.exit == 1 && `(${t('escape')})` || ``}</span>
                </Link>
                </Space>
                {
                    r.playerHandle === game[`captain${r.team}`] ? <Captain style={{ position: "absolute", bottom: '30%', left: -12, zIndex: 10 }}/> : null
                }

                {
                    r.selectNum > 2 ? <div className={'circle'} style={{ position: "absolute", top: 0, left: -6, zIndex: 10 }}>{r.selectNum - 2}</div> : null
                }

                {
                    r.mvp == 1 ? <Mvp style={{ position: "absolute", bottom: '30%', right: 0 }}/> : null
                }
                {
                    r.mvp == 2 ? <Svp style={{ position: "absolute", bottom: '30%', right: 0 }}/> : null
                }


            </div>,
            align: 'left',
            sorter: (a, b) => {
                if (a.selectNum !== b.selectNum) {
                    return a.selectNum - b.selectNum
                } else {
                    return a.teamPlace - b.teamPlace
                }
            },
            width: "240px"
        },
        {
            key: 'heroLevel',
            dataIndex: 'heroLevel',
            title: t('level'),
            align: 'center',
            sorter: (a, b) => a.heroLevel - b.heroLevel,
        },
        {
            key: 'kill',
            dataIndex: 'kill',
            title: t('kill'),
            align: 'center',
            sorter: (a, b) => a.kill - b.kill,
        },
        {
            key: 'death',
            dataIndex: 'death',
            title: t('death'),
            align: 'center',
            sorter: (a, b) => a.death - b.death,
        },
        {
            key: 'assist',
            dataIndex: 'assist',
            title: t('assist'),
            align: 'center',
            sorter: (a, b) => a.assist - b.assist,
        },
        {
            key: 'fightPct',
            dataIndex: 'fightPct',
            title: t('matchInfo.fightPct'),
            align: 'center',
            render: (fightPct) => `${fightPct}%`,
            sorter: (a, b) => a.fightPct - b.fightPct,
        },
        {
            key: 'damage',
            dataIndex: 'damage',
            title: t('matchInfo.damage'),
            align: 'center',
            sorter: (a, b) => a.damage - b.damage,
        },
        {
            key: 'damagePct',
            dataIndex: 'damagePct',
            title: t('matchInfo.damagePct'),
            align: 'center',
            render: (damagePct) => `${damagePct}%`,
            sorter: (a, b) => a.damagePct - b.damagePct,
        },
        {
            key: 'damaged',
            dataIndex: 'damaged',
            title: t('matchInfo.damaged'),
            align: 'center',
            sorter: (a, b) => a.damaged - b.damaged,
        },
        {
            key: 'money',
            dataIndex: 'money',
            title: t('matchInfo.money'),
            align: 'center',
            sorter: (a, b) => a.money - b.money,
        },
        {
            key: 'mainRune',
            dataIndex: 'mainRune',
            title: t('matchInfo.mainRune'),
            align: 'center',
            render: (_, p) => <Icon type={'rune'} size={28} name={`${p.primaryColumn}_${p.primaryRunes.split(' ')[5]}`}></Icon>,
        },
        {
            key: 'mmr',
            dataIndex: 'mmr',
            title: t('mmr'),
            align: 'center',
            render: (_, p) => <>
                <b>{p.mmr}</b>
                <span> </span>
                {
                    p.mmrChange >= 0 ? <b style={{ color: "#52c41a" }}>+</b> : null
                }

                <b style={{ color: p.mmrChange >= 0 ? "#52c41a" : "#f5222d" }}>{p.mmrChange}</b>
            </>,
        },
    ]
    const data = game.playerList.filter(p => p.team == team).sort((a, b) => {
        if (a.selectNum !== b.selectNum) {
            return a.selectNum - b.selectNum
        } else {
            return a.teamPlace - b.teamPlace
        }
    })
    if (data.length > 0) {
        const totalKill = data.reduce((prev, curr) => (typeof prev.kill === "number") ? prev.kill + curr.kill : prev + curr.kill)
        const damageKill = data.reduce((prev, curr) => (typeof prev.damage === "number") ? prev.damage + curr.damage : prev + curr.damage)
        for (const p of data) {
            p.fightPct = Math.ceil((p.kill + p.assist) / totalKill * 1000) / 10
            p.damagePct = Math.ceil(p.damage / damageKill * 1000) / 10
        }
        setKey(data, "playerId")
    }

    useEffect(() => {

    }, [])

    return <Space direction={'vertical'}>

        <Table onRow={(r) =>
            (r.playerHandle == prop.playerHandle || (!prop.playerHandle && r.heroId == prop.heroId)) ? {style: {background: "#e6fffb"}} : {}
        } expandable={{
            expandedRowRender: (record) => <MatchHeroInfo hero={record}/>,
            rowExpandable: () => true,
            expandRowByClick: true,
            expandIcon: () => null,
            showExpandColumn: false,
            // expandedRowKeys: [],
            onExpand: (_, r) => {}
        }} style={{width: '1000px'}} size={'small'} columns={columns} pagination={false} dataSource={data} />

    </Space>
}
